import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface IPagination {
  AvailableSchedulePage: number
  AvailableSchedulePageTotalItems: number | undefined
  AvailableSchedulePageTotalPages: number | undefined
  InterviewsPage: number
  InterviewsTotalItems: number | undefined
  InterviewsTotalPages: number | undefined
  StatisticPage: number
  StatisticTotalItems: number | undefined
  StatisticTotalPages: number | undefined
  InterwiewersPage: number
  InterwiewersTotalItems: number | undefined
  InterwiewersTotalPages: number | undefined
}

const InterviewsPaginationState: IPagination = {
  AvailableSchedulePage: 1,
  AvailableSchedulePageTotalItems: undefined,
  AvailableSchedulePageTotalPages: undefined,
  InterviewsPage: 1,
  InterviewsTotalItems: undefined,
  InterviewsTotalPages: undefined,
  StatisticPage: 1,
  StatisticTotalItems: undefined,
  StatisticTotalPages: undefined,
  InterwiewersPage: 1,
  InterwiewersTotalItems: undefined,
  InterwiewersTotalPages: undefined,
}

const PaginationSlice = createSlice({
  name: "InterviewsPagination",
  initialState: InterviewsPaginationState,
  reducers: {
    setAvailableSchedulePage: (state, action: PayloadAction<number>) => {
      state.AvailableSchedulePage = action.payload
    },
    setAvailableScheduleTotalItems: (state, action: PayloadAction<number>) => {
      state.AvailableSchedulePageTotalItems = action.payload
    },
    setAvailableScheduleTotalPages: (state, action: PayloadAction<number>) => {
      state.AvailableSchedulePageTotalPages = action.payload
    },
    setInterviewsPage: (state, action: PayloadAction<number>) => {
      state.InterviewsPage = action.payload
    },
    setInterviewsTotalItems: (state, action: PayloadAction<number>) => {
      state.InterviewsTotalItems = action.payload
    },
    setInterviewsTotalPages: (state, action: PayloadAction<number>) => {
      state.InterviewsTotalPages = action.payload
    },
    setStatisticPage: (state, action: PayloadAction<number>) => {
      state.StatisticPage = action.payload
    },
    setStatisticTotalItems: (state, action: PayloadAction<number>) => {
      state.StatisticTotalItems = action.payload
    },
    setStatisticTotalPages: (state, action: PayloadAction<number>) => {
      state.StatisticTotalPages = action.payload
    },
    setInterwiewersPage: (state, action: PayloadAction<number>) => {
      state.InterwiewersPage = action.payload
    },
    setInterwiewersItems: (state, action: PayloadAction<number>) => {
      state.InterwiewersTotalItems = action.payload
    },
    setInterwiewersTotalPages: (state, action: PayloadAction<number>) => {
      state.InterwiewersTotalPages = action.payload
    },
  },
})

export const InterviewsPaginationReducer = PaginationSlice.reducer
export const {
  setAvailableSchedulePage,
  setAvailableScheduleTotalItems,
  setAvailableScheduleTotalPages,
  setInterviewsPage,
  setInterviewsTotalItems,
  setInterviewsTotalPages,
  setStatisticPage,
  setStatisticTotalItems,
  setStatisticTotalPages,
  setInterwiewersPage,
  setInterwiewersItems,
  setInterwiewersTotalPages,
} = PaginationSlice.actions
